import { render, staticRenderFns } from "./OrthographiqLogo.vue?vue&type=template&id=d252cb64&scoped=true&"
import script from "./OrthographiqLogo.vue?vue&type=script&lang=js&"
export * from "./OrthographiqLogo.vue?vue&type=script&lang=js&"
import style0 from "./OrthographiqLogo.vue?vue&type=style&index=0&id=d252cb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d252cb64",
  null
  
)

export default component.exports